const MoreVerticalIcon = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
		<path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
	</svg>
);

MoreVerticalIcon.displayName = 'MoreVerticalIcon';

export { MoreVerticalIcon };
